import React from 'react';
import utils from '../../utils';
import fetch from '../fetch';
import {Tag} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columnsArray = [
    {type: 'selection'},
    {key:'$index', width: 70, label: '序号'},
    {
        key: 'orgName', width: 100,
        label: '所属部门'
    },
    {
        key: 'className', width: 100,
        label: '班级名称',
    },
    {
        key: 'objectCode', width: 100,
        label: '对象编号'
    },
    {
        key: 'objectName', width: 100,
        label: '对象名称'
    },
    {
        key: 'objectType', width: 80,
        label: '对象类型',
        render: (data) => {
            var objectType = JSON.parse(data)
            if(objectType==0){
                return '专业';
            }else if(objectType==1){
                return '教师';
            }else if(objectType==2){
                return '课程';
            }else if(objectType==3){
                return '班级';
            }else if(objectType==4){
                return '学生';
            }else if(objectType==5){
                return '部门';
            }else if(objectType==6){
                return '团队';
            }else {
                return '未知类型';
            }
        } 
    },
    {
        key: 'targetName', width: 100,
        label: '指标名称',
    },
    {key: 'reviewState', label:'评审状态' , width : 100 , render:(val)=>{
        if(val === 0){
            return <Tag color='#2db7f5'>待分配评审</Tag>
        }else if(val === 1){
            return <Tag color='#1890ff'>待评审</Tag>
        }else if(val === 2){
            return <Tag color='#722ed1'>评审中</Tag>
        }else if(val >= 3){
            return <Tag color='#87d068'>已评审</Tag>
        }
    } },
    {
        key: 'masterName', width: 130,
        label: '评审专家'
    },{
        key: 'termName', width: 120,
        label: '学期'
    },
]

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', width: 70, label: '序号'},
    {
        key: 'orgName', width: 100,
        label: '所属部门'
    },
    {
        key: 'className', width: 100,
        label: '班级名称',
    },
    {
        key: 'objectName', width: 100,
        label: '对象名称'
    },
    {
        key: 'objectType', width: 80,
        label: '对象类型',
        render: (data) => {
            var objectType = JSON.parse(data)
            if(objectType==0){
                return '专业';
            }else if(objectType==1){
                return '教师';
            }else if(objectType==2){
                return '课程';
            }else if(objectType==3){
                return '班级';
            }else if(objectType==4){
                return '学生';
            }else if(objectType==5){
                return '部门';
            }else if(objectType==6){
                return '团队';
            }else {
                return '未知类型';
            }
        } 
    },
    {
        key: 'targetName', width: 100,
        label: '指标名称',
    },
    {key: 'reviewState', label:'评审状态' , width : 100 , render:(val)=>{
        if(val === 0){
            return <Tag color='#2db7f5'>待分配评审</Tag>
        }else if(val === 1){
            return <Tag color='#1890ff'>待评审</Tag>
        }else if(val === 2){
            return <Tag color='#722ed1'>评审中</Tag>
        }else if(val >= 3){
            return <Tag color='#87d068'>已评审</Tag>
        }
    } },
    {
        key: 'masterName', width: 130,
        label: '评审专家'
    },{
        key: 'termName', width: 120,
        label: '学期'
    },
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    
    return fetch.post('zgcp/expert/assign/query?'+ params.join('&'), Object.assign({
    }, defaultsParams, newKeyword))
    .then(response => {
        let extParams = response.payload.meta.extParams;
        let newArray = [] 
        if(extParams) {
            for(let i = 0; i < columnsArray.length; i++) {
                if(columnsArray[i].key != 'className'&& columnsArray[i].key != 'objectCode'){
                    newArray.push(columnsArray[i])
                }
                if((extParams.objectType == 4 || extParams.objectType == 1 ) && columnsArray[i].key == 'objectCode'){
                    newArray.push(columnsArray[i])
                }
                if(extParams.objectType == 4 && columnsArray[i].key == 'className'){
                    newArray.push(columnsArray[i])
                }
                if(i === 9) {
                    if(extParams.options.length > 0){
                        extParams.options.forEach(o => {
                            var key = o.name;
                            if(key.indexOf("FILEVO-") != -1){
                                newArray.push({
                                    key: o.name,
                                    label: o.value, 
                                    width: 120,
                                    render: (files) => {
                                        if(files && files.length > 0) {
                                            return (
                                                <ol className="upper-alpha">
                                                    {
                                                        files.map((file) => (
                                                            <li><a href={window.base + 'zgcp/enter/file/download?id=' + file.id} target="_blank">{ file.fileName }</a></li>
                                                        ))
                                                    }
                                                </ol>
                                            )
                                        }
                                        return "无";
                                    }
                                })
                            }else{
                                newArray.push({
                                    key: o.name,
                                    label: o.value, 
                                    width: 120
                                })
                            }
                        })
                    }
                    if(extParams.teamDetail && extParams.teamDetail.length > 0){
                        extParams.teamDetail.forEach(o => {
                            newArray.push({
                                key: o.name,
                                label: o.value, 
                                width: 120
                            })
                        })
                    }
                }
            }
        }
        return {
            data: response.payload.data,
            meta: response.payload.meta,
            headers: utils.columns(newArray.length > 0 ? newArray :columnsArray)
        };
    })
    .then(res => (Object.assign({
        headers: res.headers,
        result: (res.data.dataList || []).map(d => {
            return Object.assign({}, d, {
                height: (d.fileMaxRow != null ? d.fileMaxRow * 30 : 30)
            })
        }),
        selects: (res.data.dataList || []).map((d,i) => ({
            value: d.resultId,
            checked: false,
            height: (d.fileMaxRow != null ? d.fileMaxRow * 30 : 30)
        })),
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const getCheckMasterById = (id) => {
    return fetch.post(`zgcp/expert/assign/getResultMaster/${id}` , {})
}

const updateMaster = (id , params) => {
    return fetch.post(`zgcp/expert/assign/updateMaster/${id}` ,params)
}

const saveMaster = (data) => {
    return fetch.post(`zgcp/expert/assign/save` ,data)
}

const publicApproval = (data) => {
    return fetch.post(`zgcp/expert/assign/publicApproval` ,data)
}

const querySearchExpertByName = (keywords ={}) => {
    return fetch.post('employee/findExpert/by/realname', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.employeeId,
            employeeNo: d.loginName,
            label: d.doubleName?d.realName+" ("+d.employeeCode+")":d.realName,
        }));
    });
}

export default {
    setRefresh,
    onSelect,
    getSelection,
    headers,
    querySearch,
    getCheckMasterById ,
    updateMaster ,
    saveMaster ,
    publicApproval,
    querySearchExpertByName
}